module.exports = __webpack_public_path__ + "static/5-55b271429b8e434c6eb2e082e81d2c8c.jpeg";